import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string } | ReactNode;
}

export default function SectionHeader({ eyebrow, title, description, action }: SectionHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-6 h-[3px] rounded-full bg-accent-500" />
            <span className="text-[11px] font-label font-semibold tracking-[0.2em] uppercase text-accent-700">
              {eyebrow}
            </span>
          </div>
        )}
        <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950 tracking-tight">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{description}</p>}
      </div>
      {action && (
        <div className="shrink-0">
          {typeof action === "object" && action !== null && "to" in action ? (
            <Link
              to={(action as { to: string }).to}
              className="inline-flex items-center gap-1.5 text-sm font-label font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              {(action as { label: string }).label}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>
          ) : (
            action as ReactNode
          )}
        </div>
      )}
    </div>
  );
}